import * as React from "react";
import { Button, Modal, Input, Label, SemanticCOLORS, InputOnChangeData } from "semantic-ui-react";

import { toast } from "../toasts";

interface Props {
    isOpen: boolean;
    promptText: string;
    headingText?: string;
    typeToConfirmText?: string;
    confirmText?: string;
    cancelText?: string;
    confirmButtonColor?: SemanticCOLORS;
    onConfirm: () => void;
    onClose: () => void;
    preventOnCloseAfterSubmit?: boolean;
}

export const ConfirmModal: React.FunctionComponent<Props> = (props: Props) => {

    const [confirmAttempted, setConfirmAttempted] = React.useState<boolean>(false);
    const [enteredConfirmationText, setEnteredConfirmationText] = React.useState<string>("");

    const onConfirmationTextChange = React.useCallback((_event: React.ChangeEvent<HTMLInputElement>, data: InputOnChangeData) => {
        setEnteredConfirmationText(data.value);
    }, []);

    const close = React.useCallback((isFromClose: boolean) => {
        setConfirmAttempted(false);
        setEnteredConfirmationText("");
        if (isFromClose || !props.preventOnCloseAfterSubmit) {
            props.onClose();
        }
    }, [props]);

    const onClose = React.useCallback(() => close(true), [close]);

    const confirm = React.useCallback(() => {
        setConfirmAttempted(true);
        if (!props.typeToConfirmText || props.typeToConfirmText === enteredConfirmationText) {
            props.onConfirm();
            close(false);
        } else {
            toast.warning("Confirmation Text does not match!");
        }
    }, [close, enteredConfirmationText, props]);

    return (
        <Modal size="mini" open={props.isOpen}>
            {props.headingText &&
                <Modal.Header>
                    {props.headingText}
                </Modal.Header>
            }
            <Modal.Content>
                <div className="confirmModalPromptText">{props.promptText}</div>
                {props.typeToConfirmText &&
                    <Input fluid onChange={onConfirmationTextChange} />}
                {props.typeToConfirmText && confirmAttempted && props.typeToConfirmText !== enteredConfirmationText &&
                    <Label basic color="red" pointing>Entered text does not match "{props.typeToConfirmText}"</Label>}
            </Modal.Content>
            <Modal.Actions>
                <Button onClick={onClose}>{props.cancelText || "Cancel"}</Button>
                <Button
                    negative={props.confirmButtonColor ? false : true}
                    onClick={confirm}
                    color={props.confirmButtonColor}
                >
                    {props.confirmText || "Confirm"}
                </Button>
            </Modal.Actions>
        </Modal>
    );
};
